import React from "react";
import { CheckIcon } from "lucide-react";
import { guides } from "../data/guides";
import { CtaButton } from "./CtaButton";
export function GuidesSection() {
  return <section className="bg-cream py-20 md:py-28" aria-labelledby="guides-title" data-id="element-119" data-mp="2gnpa4tzjxwlw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-120" data-mp="2glm8tdsy8h1v">
        <div className="max-w-2xl" data-id="element-121" data-mp="2bpe12lh2zq4q">
          <h2 id="guides-title" className="font-display text-4xl uppercase leading-none text-ink md:text-6xl" data-id="element-122" data-mp="2bocbzd38d340">
            Ce que vous allez recevoir
          </h2>
          <p className="mt-6 font-serif text-lg italic text-stone" data-id="element-123" data-mp="22mmky8d9g66r">
            Comme les touches d'un piano : une noire et une blanche qui jouent ensemble.
          </p>
        </div>

        <div className="mt-14 grid overflow-hidden rounded-2xl border border-walnut/15 shadow-[0_20px_50px_-30px_rgba(63,39,23,0.5)] md:grid-cols-2" data-id="element-124" data-mp="1sr1n8mf85s2t">
          {guides.map(g => {
          const dark = g.tone === "dark";
          return <article key={g.id} className={`flex flex-col p-8 md:p-12 ${dark ? "bg-ebony" : "bg-linen"}`} data-id="element-125" data-mp="25nh0ecj09emn">
                <p className={`text-xs font-semibold uppercase tracking-[0.2em] ${dark ? "text-brass" : "text-wood"}`} data-id="element-126" data-mp="2anv79r8veij3">
                  {g.audience}
                </p>
                <h3 className={`mt-3 font-serif text-3xl md:text-4xl ${dark ? "text-linen" : "text-ink"}`} data-id="element-127" data-mp="2odyrkco6w25w">
                  {g.title}
                </h3>
                <p className={`mt-4 leading-relaxed ${dark ? "text-sand/80" : "text-stone"}`} data-id="element-128" data-mp="2emu8p1ve7x5s">
                  {g.description}
                </p>
                <ul className="mt-8 space-y-4" data-id="element-129" data-mp="2jkm5oaawa9gu">
                  {g.items.map(item => <li key={item} className="flex gap-3" data-id="element-130" data-mp="37aq668ssdt3m">
                      <CheckIcon className={`mt-0.5 h-5 w-5 shrink-0 ${dark ? "text-brass" : "text-walnut"}`} aria-hidden="true" data-id="element-131" data-mp="3c41e6d9c4fx4" />
                      <span className={dark ? "text-linen" : "text-ink"} data-id="element-132" data-mp="3h1gkevx0b4dt">{item}</span>
                    </li>)}
                </ul>
              </article>;
        })}
        </div>

        <div className="mt-12 flex justify-center" data-id="element-133" data-mp="37yz1aqcnerv1">
          <CtaButton data-id="element-134" data-mp="330xfvyrr2gge" />
        </div>
      </div>
    </section>;
}